import { Component, Input, OnInit } from '@angular/core';

import { BetBuilderFixture } from '@cds/betting-offer/domain-specific/bet-builder';
import { BetBuilderConfig } from '@frontend/sports/common/client-config-data-access';

import { PromotedBetBuilderService } from '../../../betbuilder/services/promoted-betbuilder.service';
import { ComponentProxy } from '../../../deferred/component-loader.service';
import { ComponentProxyDirective } from '../../../deferred/component-proxy.directive';
import {
    HighLightsMarqueeBinding,
    HighlightsMarqueeComponentLoaderService,
} from '../../../highlights-marquee/highlights-marquee-component-loader.service';
import { HighlightsMarqueePage } from '../../../highlights-marquee/highlights-marquee-page.enum';
import { BetBuilderTile } from '../../../highlights-marquee/marquee-tile.model';

@Component({
    selector: 'ms-promoted-betbuilder',
    templateUrl: './promoted-betbuilder.component.html',
    imports: [ComponentProxyDirective],
})
export class PromotedBetBuilderComponent implements OnInit {
    @Input() promotedMarkets: BetBuilderFixture[];

    page: HighlightsMarqueePage = HighlightsMarqueePage.BetbuilderCarousel;
    promotedMarketsPage: number;
    promotedMarketsCount: number;
    promotedMarketTiles?: BetBuilderTile[];
    marqueeComponent: ComponentProxy<HighLightsMarqueeBinding>;
    constructor(
        private promotedBetBuilderService: PromotedBetBuilderService,
        private betBuilderConfig: BetBuilderConfig,
        private marqueeLoader: HighlightsMarqueeComponentLoaderService,
    ) {
        this.promotedMarketsPage = 1;
        this.marqueeComponent = this.marqueeLoader.getHighlightsMarqueeComponent();
    }

    ngOnInit(): void {
        this.promotedMarketsCount = this.promotedMarkets.length;
        this.promotedMarketTiles = this.promotedBetBuilderService.mapTiles(this.promotedMarkets);
        this.marqueeComponent.update({
            tiles: this.promotedMarketTiles,
            page: this.page,
        });
    }

    get hasMorePromotedMarkets(): boolean {
        return this.promotedMarketsCount > this.promotedMarketsPage * this.betBuilderConfig.pageSize;
    }
}
